// extracted by mini-css-extract-plugin
export default {"modalOverlay":"UD-z","modalContent":"VD-z","header":"WD-z","close":"XD-z"};